import { Box, BoxProps, Heading, HeadingProps, useColorModeValue } from "@chakra-ui/react";
import { useState } from "react";

const collapsedWidth = "3px";
const expandedWidth = "8px";
const hoverOffset = "5%";

export function HighlightedBlock({ children, ...props }: BoxProps) {
    const [hover, setHover] = useState(false);

    return (
        <Box
            onMouseEnter={() => setHover(true)}
            onMouseLeave={() => setHover(false)}
            py={2}
            position="relative"
            paddingLeft={hover ? expandedWidth : collapsedWidth}
            paddingRight={hover ? collapsedWidth : expandedWidth}
            transition="all 0.2s ease-in-out"
            {...props}
        >
            <Box
                position="absolute"
                top={hover ? hoverOffset : 0}
                left={0}
                bottom={hover ? hoverOffset : 0}
                width={hover ? expandedWidth : collapsedWidth}
                transition="all 0.2s ease-in-out"
                backgroundColor={useColorModeValue("brand.500", "brand.400")}
            />
            <Box pl={4}>{children}</Box>
        </Box>
    );
}

export function HighlightedBlockHeading(props: HeadingProps) {
    return (
        <Heading
            fontSize="1xl"
            fontWeight={"semibold"}
            color={useColorModeValue("brand.500", "brand.400")}
            {...props}
        />
    );
}
